import React from 'react';
import { CommandChannelClient } from '../index-types';
export default React.createContext<CommandChannelClient | null>(null);
